const pagesIndividualOfficialDocumentsEn = {
  column: {
    document: 'Document',
    issuedDate: 'Issued',
    kind: 'Type',
    procedure: 'Procedure'
  },
  downloadAction: 'Download',
  downloadFailed: 'Download failed. Please try again later.',
  empty: 'You have no documents yet.',
  kind: {
    officialDocument: 'Official document'
  },
  loadError: 'Failed to load your documents.',
  pageDescription: 'Official documents issued by the authorities for procedures your company filed on your behalf.',
  pageTitle: 'Documents',
  status: {
    preparing: 'Being prepared'
  }
};
export default pagesIndividualOfficialDocumentsEn;